/**
 * Resolves stored media paths to absolute URLs.
 *
 * Paths from the database look like: /uploads/images/uuid.jpg
 * These are relative to the Story Builder backend (REACT_APP_STORY_BUILDER_URL),
 * the same service src/api/client.js talks to — not the main portal API.
 * External URLs (Unsplash, Giphy, data:) pass through unchanged.
 */

export const API_URL = process.env.REACT_APP_STORY_BUILDER_URL || '';

export function resolveMediaUrl(src) {
  if (!src) return '';
  if (
    src.startsWith('http://') ||
    src.startsWith('https://') ||
    src.startsWith('data:') ||
    src.startsWith('//')
  ) {
    return src;
  }
  // Relative path — prepend the backend origin
  return `${API_URL}${src}`;
}
